import { ProcesarDatosApi } from "../api/ApiFetch";
const controlador = "login";

export const IniciarSesion = async (data) => {
    const url = `${controlador}/IniciarSesion`;
    return await ProcesarDatosApi('POST', url, data);
}